export const dimensionUnits = {
  ft: { text: 'Feet', value: 'ft' },
  in: { text: 'Inch', value: 'in' },
  mm: { text: 'Milimeter', value: 'mm' },
};

export const weightUnits = {
  lb: { text: 'Pound', value: 'lb' },
  kg: { text: 'Kg', value: 'kg' },
  ton: { text: 'Ton', value: 'ton' },
};

export const palletTypes = {
  eu: { text: 'Euro Pallet', value: 'eu' },
  uk: { text: 'UK Pallet', value: 'uk' },
};
